'use client'

import { useCallback } from 'react'

import { RefreshRouteOnSave } from '@payloadcms/live-preview-react'
import { useRouter } from 'next/navigation'

/**
 * Re-renders the current route on every save event from cms-portal's admin, for a page whose
 * content is resolved on the server.
 *
 * The homepage's rows are resolved and prefetched server-side (LaunchDarkly gates, seller scoping,
 * search endpoints), so a client-side merge of the admin form's data could not render them
 * faithfully. Instead each save (autosave every few seconds, Save Draft, Publish) triggers
 * `router.refresh()`; the URL still carries `previewToken`, so the server re-fetches the draft and
 * the whole pipeline runs again. The pane lags a keystroke by the autosave interval, which is the
 * trade for showing exactly what the resolvers would do with the draft.
 *
 * Renders nothing. Mount it only on a request the page has verified as a preview.
 */
export default function CmsRefreshOnSave({ serverURL }: { serverURL: string }) {
  const router = useRouter()
  const refresh = useCallback(() => router.refresh(), [router])
  return <RefreshRouteOnSave serverURL={serverURL} refresh={refresh} />
}
